import type { IrKvp } from "./IrKvp";

export class IrMap<K = string, V = string, G = string> extends Array<IrKvp<K, V, G>> {}
